import {
  Box,
  VStack,
  Select,
  Modal,
  Heading,
  Text,
  Divider,
  Button,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  HStack,
  SimpleGrid,
  ModalOverlay,
  ModalContent,
  ModalFooter,
  Image,
  useDisclosure,
} from "@chakra-ui/react";
import { useState } from "react";
import Animated from "./AnimatedSection";
import star from "../../assets/images/yellowstar.png";
import { countryData, events } from "../../data/Event";

const EventsSection = () => {
  const [selectedEvent, setSelectedEvent] = useState(events[0]);
  const [cities, setCities] = useState(countryData[0]?.cities || []);
  const { isOpen, onOpen, onClose } = useDisclosure();

  const formUrl =
    "https://forms.zohopublic.com/IDEATORSCUP/form/CYPRUSROUNDREGISTRATION/formperma/Tyx16DXRUfRvZhmvGzZIq3-AiDXmFma208KpF8Ib9S4";

  const [selectedCountry, setSelectedCountry] = useState(
    countryData[0]?.country || ""
  );

  const handleCountryChange = (e) => {
    const selected = e.target.value;
    setSelectedCountry(selected);

    const foundCountry = countryData.find((c) => c.country === selected);
    setCities(foundCountry ? foundCountry.cities : []);
  };

  const handleRegisterClick = () => {
    if (selectedCountry === "North Cyprus") {
      window.open(formUrl, "_blank", "noopener,noreferrer");
    } else {
      onOpen();
    }
  };

  const {
    isOpen: isOpenModal,
    onOpen: onOpenModal,
    onClose: onCloseModal,
  } = useDisclosure();

  const handleEventClick = (event) => {
    setSelectedEvent(event);
    onOpenModal();
  };

  return (
    <Animated>
      <Box id="events" mx="auto" textAlign="center" w="90%">
        <Animated>
          <Heading color="white" fontSize={{ base: "26px", lg: "42px" }}>
            OUR EVENTS
          </Heading>
          <Text mt={2} color="white" w="90%" mx="auto">
            Where you bring your ideas to real life
          </Text>
        </Animated>

        <Animated>
          <SimpleGrid w="100%" columns={{ base: 1, lg: 3 }} spacing={5} py={4}>
            {events.map((event) => {
              const isSelected = selectedEvent?.id === event.id;

              return (
                <Box
                  key={event.id}
                  position="relative"
                  width="100%"
                  cursor="pointer"
                  h={{ base: "250px", lg: "320px" }}
                  borderRadius="32px"
                  overflow="hidden"
                  transition="all 0.3s ease-in-out"
                  _hover={{
                    transform: "scale(1.02)",
                    filter: "brightness(1)",
                    boxShadow: "0px 8px 16px rgba(0, 0, 0, 0.3)",
                  }}
                >
                  <Image
                    src={require(`../../assets/images/${event.image}`)}
                    width="100%"
                    height="100%"
                    objectFit="cover"
                    transition="filter 0.3s ease-in-out"
                  />
                  <Box
                    position="absolute"
                    top="0"
                    left="0"
                    bg={"rgba(0,0,0,0.4)"}
                    
                    width="100%"
                    height="100%"
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    transition="opacity 0.3s ease-in-out"
                    borderRadius="32px"
                  >
                    <VStack w="80%" textAlign="center">
                      <Heading
                        fontSize="28px"
                        fontWeight="bold"
                        color={"white"}
                      >
                        {event?.title}
                      </Heading>
                      <Text color="white" fontWeight="bold">
                        {event?.subtitle}
                      </Text>
                      <Button
                        bg="brand.150"
                        color="white"
                        _hover={{ color: "brand.200", bg: "brand.150" }}
                        onClick={() => handleEventClick(event)}
                        cursor="pointer"
                      >
                        Learn More
                      </Button>
                    </VStack>
                  </Box>
                </Box>
              );
            })}
          </SimpleGrid>

          {selectedEvent && (
            <Modal
              isOpen={isOpenModal}
              onClose={onCloseModal}
              size={{ base: "xs", md: "xl", lg: "3xl" }}
              isCentered
            >
              <ModalOverlay />
              <ModalContent
                bg="rgba(34, 40, 61, 1)"
                color="white"
                borderRadius="24px"
                maxH="90vh"
                overflow="hidden"
              >
                <ModalHeader px={4}>{selectedEvent.title}</ModalHeader>
                <ModalCloseButton />

                <ModalBody overflowY="auto" maxH="75vh" p={4}>
                  <Box borderRadius="24px" bg="brand.100" color="white">
                    <Heading fontSize="18px">REGISTRATION</Heading>
                    <Box
                      mt={2}
                      w="30%"
                      h="5px"
                      bg="brand.200"
                      borderRadius="full"
                    />

                    <Select
                      mt={4}
                      onChange={handleCountryChange}
                      bg="brand.100"
                    >
                      {countryData.map((item) => (
                        <option
                          key={item.country}
                          value={item.country}
                          style={{
                            backgroundColor: "rgba(34, 40, 61, 1)",
                            color: "white",
                          }}
                        >
                          {item.country}
                        </option>
                      ))}
                    </Select>

                    <Select mt={4} bg="brand.100" isDisabled={!selectedCountry}>
                      {cities.map((city) => (
                        <option
                          key={city}
                          value={city}
                          style={{
                            backgroundColor: "rgba(34, 40, 61, 1)",
                            color: "white",
                          }}
                        >
                          {city}
                        </option>
                      ))}
                    </Select>

                    <Button
                      mt={4}
                      w="100%"
                      borderRadius="12px"
                      bg="brand.150"
                      _hover={{ bg: "brand.200" }}
                      onClick={handleRegisterClick}
                    >
                      Register
                    </Button>
                  </Box>

                  {/* Event Information */}
                  <Box mt={8} borderRadius="24px" bg="brand.100">
                    <Heading fontSize="18px">INFORMATION</Heading>
                    <Box
                      mt={2}
                      w="30%"
                      h="5px"
                      bg="brand.200"
                      borderRadius="full"
                    />

                    <VStack mt={4} align="start" spacing={3}>
                      <Text>
                        <b>Category:</b> {selectedEvent?.category}
                      </Text>
                      <Divider bg="brand.100" />
                      <Text>
                        <b>Word Limit:</b> {selectedEvent?.wordLimit}
                      </Text>
                      <Divider bg="brand.100" />
                      <Text>
                        <b>Theme:</b> {selectedEvent?.theme}
                      </Text>
                      <Divider bg="brand.100" />
                      <Text>
                        <b>Format:</b> {selectedEvent?.format}
                      </Text>
                      <Divider bg="brand.100" />
                      <Text>
                        <b>Date:</b> {selectedEvent?.date}
                      </Text>
                      <Divider bg="brand.100" />
                      <Text>
                        <b>Time:</b> {selectedEvent?.time}
                      </Text>
                      <Divider bg="brand.100" />
                      <Text>
                        <b>Country:</b> {selectedEvent?.country}
                      </Text>
                      <Divider bg="brand.100" />
                      <Text>
                        <b>Venue:</b> {selectedEvent?.venue}
                      </Text>
                    </VStack>
                  </Box>
                  {/* Event Image */}
                  <Box mt={4} borderRadius="24px" bg="brand.100">
                    <Image
                      src={require(`../../assets/images/${selectedEvent.image}`)}
                      w="100%"
                      h="100%"
                      objectFit="cover"
                      borderRadius="md"
                    />
                  </Box>

                  {/* Event Details */}
                  <Box mt={4}>
                    <Heading fontSize={{ base: "20px", lg: "28px" }}>
                      {selectedEvent?.storytitle}
                    </Heading>
                    <Text my={{ base: 3, lg: 6 }} whiteSpace="break-spaces">
                      {selectedEvent?.storyDescription}
                    </Text>

                    {/* Guiding Heading */}
                    <Box>
                      <Heading fontSize={{ base: "20px", lg: "28px" }}>
                        {selectedEvent?.GuidHeading}
                      </Heading>
                      <Text my={{ base: 3, lg: 4 }}>
                        {selectedEvent?.GuiSubHeading}
                      </Text>
                    </Box>

                    {/* Evaluation Criteria */}
                    <Box mt={4}>
                      {selectedEvent?.evaluationCriteria?.map(
                        (criterion, index) => (
                          <Box key={index} mb={3}>
                            <HStack>
                              <Image w="12px" h="12px" src={star} />
                              <Text fontSize="16px">
                                {criterion.description}
                              </Text>
                            </HStack>
                            {criterion.subdescription && (
                              <Box ml={4}>
                                {criterion.subdescription.map((sub, i) => (
                                  <HStack key={i} ml={2} gap={2}>
                                    <Image
                                      mt={2}
                                      w="10px"
                                      h="10px"
                                      src={star}
                                    />
                                    <Text mt={2} fontSize="14px">
                                      {sub}
                                    </Text>
                                  </HStack>
                                ))}
                              </Box>
                            )}
                          </Box>
                        )
                      )}
                    </Box>
                  </Box>
                </ModalBody>
              </ModalContent>
            </Modal>
          )}

          <Modal
            size={{ base: "xs", md: "lg" }}
            isOpen={isOpen}
            onClose={onClose}
            isCentered
          >
            <ModalOverlay />
            <ModalContent bg="brand.100" color="white" borderRadius="12px">
              <ModalHeader>Coming Soon</ModalHeader>
              <ModalBody>
                Registration for this country is not available yet. Stay tuned!
              </ModalBody>
              <ModalFooter>
                <Button colorScheme="purple" mr={3} onClick={onClose}>
                  Close
                </Button>
              </ModalFooter>
            </ModalContent>
          </Modal>
        </Animated>
      </Box>
    </Animated>
  );
};

export default EventsSection;
